/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";
import { LogIn, LogOut, ExtenderToken, CambiarContrasena  } from "../apis";
import axios from "axios";
import toast from "react-hot-toast";
import { store } from "../store";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    usuario: {},
    token: "",
    isloadingSesion: false,
    password: null
  },
  reducers: {
    setUserLogin: (state, action) => {
      state.usuario = action.payload?.usuario;
      state.token = action.payload?.token;
      state.password = action.payload?.password;
    },
    isLoadingLogIn: (state, action) => {
      state.isloadingSesion = action.payload;
    },
    setextendToken: (state, action) => {
      state.token = action.payload.token;
    },
    updateCambioPassword: (state, action) =>{
      state.usuario = {...state.usuario, requiereCambioPassword : false};
    }
  },
});


export const {
  setUserLogin,
  isLoadingLogIn,
  setextendToken,
  updateCambioPassword
} = loginSlice.actions;

export default loginSlice.reducer;

export const LogInPublico = (username, password) => async (dispatch) => {
    dispatch(isLoadingLogIn(true));
  try {
     const datat = {
        "username": username,
        "password": password
    };
    const response = await axios.post(LogIn(), datat);
    if(response.data.code === "Ok"){
        dispatch(setUserLogin(response.data.data, password));
    }
    dispatch(isLoadingLogIn(false));
    
    return response.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    dispatch(isLoadingLogIn(false));
    return true;
  }
};

export const LogOutt = (token) => async (dispatch) => {
    try {
     const datat = {
        "token": token,
    };
    const response = await axios.post(LogOut(), datat);
    return response.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    return true;
  }
};

export const ExtenderTiempo = (usuario, token) => async (dispatch) => {
 /* const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
*/
  try {
     const datat = {
      "tokenActual": token,
      "idUsuario": usuario.idUsuario,
      "username": usuario.username,
      "nombre": usuario.nombre
    };
    const response = await axios.post(ExtenderToken(), datat);
    if(response.data.code === "Ok"){
        dispatch(setextendToken(response.data.data));
    }
    
    return response.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    return true;
  }
};

export const CmbioPassword = (password) => async (dispatch) => {
  let id = toast.loading("Procesando, por favor espere...");
  const usuario = store.getState().login.usuario;
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
    
  try {
     const datat = {
      "idUsuario": usuario?.idUsuario,
      "nuevaContrasena": password
    };
    const response = await axios.put(CambiarContrasena(), datat, header);
    if(response.data.code === "Ok"){
        toast.success("Contraseña actualizada correctamente");
        dispatch(updateCambioPassword());
    }
    toast.remove(id);
    
    return response.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    return true;
  }
};




